export const DELIVERY_PARTNER_CATEGORY_ID = 47

export const DELIVERY_PARTNER_VIEW_PERMISSION_ID = "delivery_partners_1"

/** Profile tabs with no separate manage permission (only View + sub-permission). */
export const DELIVERY_PARTNER_PROFILE_ONLY_TABS = [
  {
    subId: "view_rider_overview",
    label: "Overview tab",
    labelAr: "تبويب نظرة عامة",
  },
  {
    subId: "view_rider_status_history",
    label: "Status History tab",
    labelAr: "تبويب سجل الحالة",
  },
  {
    subId: "view_rider_orders",
    label: "Orders tab",
    labelAr: "تبويب الطلبات",
  },
  {
    subId: "view_rider_ratings",
    label: "Ratings tab",
    labelAr: "تبويب التقييمات",
  },
]

/** Tab visibility paired with a manage/action permission. */
export const DELIVERY_PARTNER_COUPLED_GROUPS = [
  {
    id: "documents",
    title: "Documents",
    titleAr: "المستندات",
    hint: "View tab controls the Documents tab in rider profile. Manage controls verification actions and document APIs.",
    hintAr:
      "تبويب العرض يتحكم في ظهور تبويب المستندات في ملف السائق. الإدارة تتحكم في التحقق من المستندات وواجهات البرمجة.",
    viewSubId: "view_rider_documents",
    viewLabel: "View Documents tab",
    viewLabelAr: "عرض تبويب المستندات",
    managePermissionId: "delivery_partners_4",
    manageLabel: "Manage documents",
    manageLabelAr: "إدارة المستندات",
  },
  {
    id: "location",
    title: "Location",
    titleAr: "الموقع",
    hint: "View tab shows location in rider profile. Manage enables live tracking, history, and geofence APIs.",
    hintAr:
      "تبويب العرض يظهر الموقع في ملف السائق. الإدارة تفعّل التتبع المباشر والسجل وواجهات السياج الجغرافي.",
    viewSubId: "view_rider_location",
    viewLabel: "View Location tab",
    viewLabelAr: "عرض تبويب الموقع",
    managePermissionId: "delivery_partners_5",
    manageLabel: "Manage location tracking",
    manageLabelAr: "إدارة تتبع الموقع",
  },
  {
    id: "earnings",
    title: "Earnings & payments",
    titleAr: "الأرباح والمدفوعات",
    hint: "Tab permissions control profile tabs. Manage permissions control earnings/COD APIs and bank details.",
    hintAr:
      "صلاحيات التبويب تتحكم في ظهور التبويبات في الملف. صلاحيات الإدارة تتحكم في واجهات الأرباح والتحصيل وتفاصيل البنك.",
    items: [
      {
        type: "viewSub",
        subId: "view_rider_earnings",
        label: "View Earnings tab",
        labelAr: "عرض تبويب الأرباح",
        requiresManageIds: ["delivery_partners_6"],
      },
      {
        type: "manage",
        permissionId: "delivery_partners_6",
        label: "Manage earnings & COD",
        labelAr: "إدارة الأرباح والتحصيل",
      },
      {
        type: "viewSub",
        subId: "view_rider_payments",
        label: "View Payments tab",
        labelAr: "عرض تبويب المدفوعات",
        requiresManageIds: ["delivery_partners_6", "delivery_partners_7"],
      },
      {
        type: "manage",
        permissionId: "delivery_partners_7",
        label: "Bank details",
        labelAr: "تفاصيل البنك",
      },
    ],
  },
]

export const DELIVERY_PARTNER_GENERAL_PERMISSIONS = [
  {
    permissionId: "delivery_partners_1",
    label: "View riders",
    labelAr: "عرض السائقين",
    description: "Access the Delivery Partners list and open rider profiles.",
    descriptionAr: "الوصول إلى قائمة شركاء التوصيل وفتح ملفات السائقين.",
  },
  {
    permissionId: "delivery_partners_2",
    label: "Add / Update",
    labelAr: "إضافة / تحديث",
  },
  {
    permissionId: "delivery_partners_3",
    label: "Delete",
    labelAr: "حذف",
  },
]

export const isDeliveryPartnerCategory = categoryId =>
  Number(categoryId) === DELIVERY_PARTNER_CATEGORY_ID

export const getLayoutLabel = (entry, language) => {
  const useAr = language === "ar" || language === "sa"
  if (useAr && entry.labelAr) return entry.labelAr
  if (useAr && entry.titleAr) return entry.titleAr
  return entry.label || entry.title || ""
}

export const getLayoutHint = (entry, language) => {
  const useAr = language === "ar" || language === "sa"
  return (useAr ? entry.hintAr : entry.hint) || entry.hint || ""
}

export const findPermission = (permissions, permissionId) =>
  (permissions || []).find(entry => String(entry.id) === String(permissionId))

export const findSubPermission = (viewPermission, subId) =>
  (viewPermission?.subPermissions || []).find(
    entry => String(entry.id) === String(subId)
  )

export const isManageEnabledForViewSub = (permissions, requiresManageIds = []) => {
  if (!requiresManageIds.length) return true
  return requiresManageIds.some(id => findPermission(permissions, id)?.isEnabled)
}

/** When enabling a manage permission, also enable the paired profile tab where applicable. */
export const getAutoEnableSubIdsForManage = managePermissionId => {
  switch (managePermissionId) {
    case "delivery_partners_4":
      return ["view_rider_documents"]
    case "delivery_partners_5":
      return ["view_rider_location"]
    case "delivery_partners_6":
      return ["view_rider_earnings"]
    case "delivery_partners_7":
      return ["view_rider_payments"]
    default:
      return []
  }
}
